export function GameLauncherSkeleton() {
  return <div className="absolute inset-0 size-full overflow-hidden rounded-md skeleton"></div>
}
